import { useEffect, ChangeEvent, useContext } from 'react'
import { useInView } from 'react-intersection-observer'
import { useNavigate } from 'react-router-dom'
import { SellersContext } from '../../../../app/contexts/SellerContex'

export const useSellersPageController = () => {
  const { ref, inView } = useInView()
  const navigate = useNavigate()

  const handleSellerDetailsPage = (id: string) => {
    navigate(`/vendedores/${id}`)
  }

  const { sellers, setSearchValue, searchValue } = useContext(SellersContext)

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } =
    sellers

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    handleSellerDetailsPage,
    data,
    isFetching,
    searchValue,
    handleSearchInputChange,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
  }
}
